import gql from "graphql-tag";

const DASHBOARD_QUERY = {
  USER_INFO_GQL: gql`query loggedUserInfoView($condition:UserInfoViewInput!) {  
    loggedUserInfoView(condition:$condition) {
        profession { 
          license_number
          profession_status
          profession_type
          profession_category
          profession_specialty
          profession_subspecialty
          cpr_number
          name_english
          name_arabic
          nationality
          passport_number
          gender_code
          birth_date
          mobile_number
          is_medical_director
          phone_number
          fax_number
          e_mail
          address_flat_no
          address_building_no
          address_road_number
          address_block_number
          address_mailbox
          address_area_code
          address_governorate_code
          issue_date
          expiry_date
          start_date
          facility_license_number, 
          work_start_date
          primary_facility
          renewal_tickler
          cpd_details
          part_time_license
          license_print_rec
          profile_pic_s3_path
          profession_privilege_mapping
          suspended_start_date
         suspended_end_date
         revoked_date
         
        }
        profession_user_rights,
        is_visitng_consultant
    }
  }`,

  GET_PROFESSION_USER_RIGHTS : gql `query getProfessionUserRights($condition:UserInfoViewInput!) {
    getProfessionUserRights(condition:$condition) {
        profession_user_rights
    }
  }`,

  FETCH_PROFESSION_APPLICATIONS_GQL: gql`query applicationViewByCondition($condition:ProfessionApplicationViewInput!) {  
    applicationViewByCondition(condition:$condition) {
        id
        apn_ref_no
        application_status
        apn_status_addl_info
        date_created
        application_type
        user_created
        profession_subspecialty
        fee
        profession_category
        profession_specialty
        profession_type
        application_info
        nhra_license_number
        user_license_number
        allow_cancel
        date_updated
  }
  }`,

  FETCH_PROFESSION_RECEIPTS_GQL: gql`query viewApplicationPaymentReceipts($condition:ProfessionApplicationViewInput!) {
    viewApplicationPaymentReceipts(condition:$condition) {
      Receipt
  }
  }`,
  NEW_USER_INFO_GQL : `query loggedUserInfoView($condition:UserInfoViewInput!) {  
    loggedUserInfoView(condition:$condition) {
        profession { 
          license_number
          profession_status
          profession_type
          profession_category
          profession_specialty
          profession_subspecialty
          cpr_number
          name_english
          name_arabic
          nationality
          passport_number
          gender_code
          birth_date
          mobile_number
          is_medical_director
          phone_number
          fax_number
          e_mail
          address_flat_no
          address_building_no
          address_road_number
          address_block_number
          address_mailbox
          address_area_code
          address_governorate_code
          issue_date
          expiry_date
          start_date
          facility_license_number, 
          work_start_date
          primary_facility
          renewal_tickler
          cpd_details
          part_time_license
          license_print_rec
          profile_pic_s3_path
          profession_privilege_mapping
        }
        profession_user_rights
    }
  }`,
  PAYMENT_HISSTORY_GQL : gql`query getNHRAProfessionPaymentInformation($condition:NHRAProfessionPaymentInformation) {
     getNHRAProfessionPaymentInformation(condition:$condition) {
      apn_ref_no
      application_date
      apn_ref_type
      fee
      date_updated
      application_status
      payment_details
      is_paid
      application_type
      profession_type
      profession_category
      paid_on
      cpr_number
      user_license_number
      fee_type
      sum_fee
      sum_fine_fee
      delay_in_days
      renewal_year
      approval_date
      last_license_expiry_date
      apn_status_code
      facility_license_number
      facility_english_name
      facility_arabic_name
      receipt_no
      applicant_name
      email
      sum_credit_fee
      passport_no
    }
  }`
  ,
  getProfessionApplicationStatusHistoryByCondition : gql `query getProfessionApplicationStatusHistoryByCondition($condition:ProfessionApplicationStatusHistoryViewInput!) { 
		getProfessionApplicationStatusHistoryByCondition(condition:$condition) {
			id
			apn_id
			apn_ref_no
			application_status
			user_audit
			addl_info
		}
	}`
}
export default DASHBOARD_QUERY;

